import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for the close event on the dialog element
    this.element.addEventListener("close", this.handleClose.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("close", this.handleClose.bind(this))
  }

  handleClose() {
    // Reset the turbo frame to show the original form by fetching it from the server
    const turboFrame = this.element.querySelector("turbo-frame#api_key_form") as any
    if (turboFrame) {
      // Set a temporary src to trigger a reload
      turboFrame.src = "/app/api_keys/new"
    }
  }
}
